/**
 * Where the billing page's "Back" goes: the last in-app page visited before
 * /billing. Browser history can't be used — every Stripe round trip (Checkout,
 * portal) and refresh adds entries, so history-back lands on Stripe or on
 * /billing again.
 */
const STORAGE_KEY = 'pf_billing_back_to'
const DEFAULT_TARGET = '/'

/** Pages Back must never return to: billing itself and the space wizard. */
const SKIPPED_PREFIXES = ['/billing', '/create-space', '/setup']

export function rememberAppPath(path: string): void {
  if (SKIPPED_PREFIXES.some((prefix) => path.startsWith(prefix))) return
  try {
    sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    // storage unavailable — Back falls back to the dashboard
  }
}

export function billingBackTarget(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || DEFAULT_TARGET
  } catch {
    return DEFAULT_TARGET
  }
}
